import { render, staticRenderFns } from "./UserInternal.vue?vue&type=template&id=ac2815fc&scoped=true"
import script from "./UserInternal.vue?vue&type=script&lang=js"
export * from "./UserInternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2815fc",
  null
  
)

export default component.exports